// extracted by mini-css-extract-plugin
export default {"tds":"TablePreloader_tds__M7GXf","moving-gradient":"TablePreloader_moving-gradient__UR-Wh"};